/**
 * Copyright 2024 Google LLC — Apache-2.0 (base repo).
 *
 * Top-level app. Every opening starts at the profile selector (Isaac / Bao / Papa).
 * A child profile mounts the Iron Man / JARVIS Gemini-Live console (the only surface
 * that talks to the Live API); Papa (PIN-gated) mounts the parent space. The chosen
 * profile also tags all API calls via the window.fetch wrapper (see kid/childSession).
 */
import "./App.scss";
import { useState } from "react";
import KidProfile from "./profiles/KidProfile";
import { ProfileSelect } from "./kid/ProfileSelect";
import { ParentSpace } from "./kid/ParentSpace";
import { getProfile, setProfile, clearProfile, Profile } from "./kid/childSession";

function App() {
  const [profile, setP] = useState<Profile | null>(getProfile());

  const choose = (p: Profile) => {
    setProfile(p);
    setP(p);
  };
  const exit = () => {
    clearProfile();
    setP(null);
  };

  if (!profile) return <ProfileSelect onSelect={choose} />;
  if (profile === "papa") return <ParentSpace onExit={exit} />;
  return <KidProfile />; // isaac | bao — the Gemini Live console
}

export default App;
